import { type Dispatch, createContext } from 'react';

import { FormFieldReducerAction } from '../state/formfield-state-reducer.js';
import type { SharedFormFieldProps } from '../types/formfield.types.js';

/**
 * @public
 */
export interface SharedFormFieldContextProps extends SharedFormFieldProps {
  dispatch?: Dispatch<FormFieldReducerAction>;
}

/**
 * @internal
 * Context provider for `FormField` props meant to be provided to all its input-related child nodes.
 */
export const _FormFieldContext = createContext<SharedFormFieldContextProps>({
  controlId: undefined,
  required: undefined,
  disabled: undefined,
  ariaDisabled: undefined,
  dispatch: undefined,
  readOnly: undefined,
});
